// extracted by mini-css-extract-plugin
module.exports = {"border":"OrderExtraField_border_2IM7f","extra-field":"OrderExtraField_extra-field_2DctC","disabled":"OrderExtraField_disabled_3sksd"};